module.exports = __webpack_public_path__ + "static/media/AFib-Worksheet-en.d8c82ab1.pdf";